"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChartCard = void 0;
var react_1 = __importDefault(require("react"));
var react_chartjs_2 = require("react-chartjs-2");
var strings_1 = __importDefault(require("../strings"));
var utils_1 = require("../utils");
var Card_1 = __importDefault(require("@material-ui/core/Card"));
var CardContent_1 = __importDefault(require("@material-ui/core/CardContent"));
var Divider_1 = __importDefault(require("@material-ui/core/Divider"));
var Grid_1 = __importDefault(require("@material-ui/core/Grid"));
var styles_1 = require("@material-ui/core/styles");
var Tooltip_1 = __importDefault(require("@material-ui/core/Tooltip"));
var Typography_1 = __importDefault(require("@material-ui/core/Typography"));
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var pro_light_svg_icons_1 = require("@fortawesome/pro-light-svg-icons");
var kinsideTokens_1 = require("../kinsideTokens");
var MAXTICKS = 20;
var useStyles = styles_1.makeStyles(function (theme) { return ({
    divider: {
        height: 4,
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
    },
    noData: {
        height: "300px",
        "flex-direction": "column",
        display: "flex",
        "align-content": "center",
        "justify-content": "center",
        fontWeight: "bold",
        fontSize: 24,
        "text-align": "center",
    },
    title: {
        fontSize: 16,
        "text-transform": "uppercase",
    },
    subtitle: {
        fontSize: 24,
        fontWeight: "bold",
    },
    icon: {
        marginLeft: theme.spacing(1),
        color: theme.palette.primary.light,
        fontSize: 24,
    },
}); });
var ChartCard = function (props) {
    var _a;
    var classes = useStyles(props);
    var colors = props.colors || [
        kinsideTokens_1.kinsideTokens["--viridian-50"],
        kinsideTokens_1.kinsideTokens["--coral-20"],
        kinsideTokens_1.kinsideTokens["--gold-30"],
        kinsideTokens_1.kinsideTokens["--periwinkle-20"],
        kinsideTokens_1.kinsideTokens["--viridian-15"],
        kinsideTokens_1.kinsideTokens["--periwinkle-60"],
    ];
    var formatDate = function (d) {
        return strings_1.default.shortMonths[d.getMonth()] + "-" + d.getDate().toString();
    };
    var formatLineData = function () {
        var now = (new Date()).valueOf();
        var data = props.dataSets.data
            .map(function (d) {
            return { date: new Date(d.date), values: Object.assign({}, d.values) };
        })
            .filter(function (d) { return (now - d.date.valueOf()) < 366 * 24 * 60 * 60 * 1000; })
            .sort(function (a, b) { return a.date.valueOf() - b.date.valueOf(); });
        var buckets = [];
        data.forEach(function (d) { return buckets = buckets.concat(Object.keys(d.values)); });
        buckets = buckets.filter(function (b, i) { return buckets.indexOf(b) === i; });
        var result = {
            labels: data.map(function (d, idx) { return formatDate(d.date); }),
            datasets: buckets.sort(function (a, b) { return a.localeCompare(b); }).map(function (bucket, idx) {
                return {
                    label: bucket,
                    fill: false,
                    lineTension: 0.1,
                    backgroundColor: colors[idx % colors.length],
                    borderColor: colors[idx % colors.length],
                    borderCapStyle: "butt",
                    borderDash: [],
                    borderDashOffset: 0.0,
                    borderJoinStyle: "miter",
                    pointBorderColor: colors[idx % colors.length],
                    pointBackgroundColor: colors[idx % colors.length],
                    pointHoverBackgroundColor: colors[idx % colors.length],
                    pointHoverBorderColor: colors[idx % colors.length],
                    pointHoverBorderWidth: 2,
                    pointRadius: 1,
                    pointHitRadius: 10,
                    data: data.map(function (d) { return d.values[bucket] || 0; }),
                };
            }),
        };
        return result;
    };
    var formatBarData = function () {
        var result = { labels: [], datasets: [] };
        var useLabels = (props.dataSets.data.length > 0) && !!props.dataSets.data[0].label;
        if (useLabels) {
            result.datasets.push({
                backgroundColor: [],
                borderColor: [],
                pointBorderColor: [],
                pointBackgroundColor: [],
                pointHoverBackgroundColor: [],
                pointHoverBorderColor: [],
                pointHoverBorderWidth: 2,
                pointRadius: 1,
                pointHitRadius: 10,
                maxBarThickness: (props === null || props === void 0 ? void 0 : props.maxBarThickness) || undefined,
                data: [],
            });
            props.dataSets.data.forEach(function (d, idx) {
                result.labels.push(d.label);
                result.datasets[0].backgroundColor.push(colors[idx % colors.length]);
                result.datasets[0].borderColor.push(colors[idx % colors.length]);
                result.datasets[0].pointBorderColor.push(colors[idx % colors.length]);
                result.datasets[0].pointBackgroundColor.push(colors[idx % colors.length]);
                result.datasets[0].pointHoverBackgroundColor.push(colors[idx % colors.length]);
                result.datasets[0].pointHoverBorderColor.push(colors[idx % colors.length]);
                result.datasets[0].data.push(d.value);
            });
        }
        else {
            var now_1 = (new Date()).valueOf();
            var data = props.dataSets.data
                .map(function (d) {
                return { date: new Date(d.date), values: Object.assign({}, d.values) };
            })
                .filter(function (d) { return (now_1 - d.date.valueOf()) < 366 * 24 * 60 * 60 * 1000; })
                .sort(function (a, b) { return a.date.valueOf() - b.date.valueOf(); });
            var firstDate = data.length ? new Date(data[0].date) : new Date();
            var buckets_1 = [];
            data.forEach(function (d) { return buckets_1 = buckets_1.concat(Object.keys(d.values)); });
            buckets_1 = buckets_1.filter(function (b, i) { return buckets_1.indexOf(b) === i; }).sort(function (a, b) { return a.localeCompare(b); });
            result.datasets = buckets_1.map(function (bucket, idx) {
                return {
                    label: bucket,
                    backgroundColor: colors[idx % colors.length],
                    borderColor: colors[idx % colors.length],
                    pointBorderColor: colors[idx % colors.length],
                    pointBackgroundColor: colors[idx % colors.length],
                    pointHoverBackgroundColor: colors[idx % colors.length],
                    pointHoverBorderColor: colors[idx % colors.length],
                    pointHoverBorderWidth: 2,
                    pointRadius: 1,
                    pointHitRadius: 10,
                    data: [],
                };
            });
            var date = new Date(firstDate);
            var _loop_1 = function () {
                var key = formatDate(date);
                result.labels.push(key);
                var d2 = data.find(function (d) { return formatDate(d.date) === key; });
                result.datasets.forEach(function (set) {
                    set.data.push(d2 ? d2.values[set.label] || 0 : 0);
                });
                date.setDate(date.getDate() + 1);
            };
            while (date <= new Date()) {
                _loop_1();
            }
        }
        return result;
    };
    var formatPieData = function () {
        var buckets = Object.keys(props.pieDataSet).sort(function (a, b) { return a.localeCompare(b); });
        var result = {
            labels: buckets,
            datasets: [{
                    label: "Buckets",
                    backgroundColor: buckets.map(function (b, idx) { return colors[idx % colors.length]; }),
                    data: buckets.map(function (b) { return props.pieDataSet[b]; }),
                }],
        };
        return result;
    };
    var getLineOptions = function () {
        var minData = currentData.datasets.reduce(function (acc, d) { return Math.min.apply(Math, __spreadArray([acc], d.data)); }, Number.MAX_SAFE_INTEGER);
        var maxData = currentData.datasets.reduce(function (acc, d) { return Math.max.apply(Math, __spreadArray([acc], d.data)); }, Number.MIN_SAFE_INTEGER);
        var stepSize;
        minData = Math.floor(Math.max(0, minData - 0.2 * (maxData - minData)));
        maxData = Math.max(5, Math.ceil(maxData + 0.2 * (maxData - minData)));
        stepSize = Math.ceil((maxData - minData) / 6);
        if (props.dataSets.percentage) {
            maxData = 100;
            minData = 10 * Math.floor(minData / 10);
            stepSize = (maxData - minData) > 60 ? 20 :
                ((maxData - minData) > 30 ? 10 :
                    ((maxData - minData) > 15 ? 5 :
                        ((maxData - minData) > 8 ? 2 : 1)));
        }
        var opt = {
            maintainAspectRatio: false,
            legend: {
                display: !!props.legend,
                position: props.legend,
                labels: {
                    usePointStyle: true,
                    pointStyle: 'circle',
                },
            },
            scales: {
                yAxes: [{
                        ticks: {
                            suggestedMin: minData,
                            suggestedMax: maxData,
                            stepSize: stepSize,
                        },
                    }],
                xAxes: [{
                        ticks: {
                            autoSkip: true,
                            maxTicksLimit: props.maxTicks || MAXTICKS,
                        },
                    }],
            },
        };
        if (props.tooltipLabel) {
            opt.tooltips = {
                enabled: true,
                callbacks: {
                    label: function (item, data) {
                        var l = data.datasets[item.datasetIndex].label ? data.datasets[item.datasetIndex].label + ": " : "";
                        return !!props.tooltipPrefix
                            ? "" + l + props.tooltipLabel + data.datasets[item.datasetIndex].data[item.index]
                            : "" + l + data.datasets[item.datasetIndex].data[item.index] + props.tooltipLabel;
                    },
                },
            };
        }
        return opt;
    };
    var getBarOptions = function () {
        var opt = {
            maintainAspectRatio: false,
            legend: {
                display: !!props.legend,
                position: props.legend,
                labels: {
                    usePointStyle: true,
                    pointStyle: 'circle',
                },
            },
            scales: {
                xAxes: [{
                        ticks: {
                            autoSkip: true,
                            maxTicksLimit: props.maxTicks || MAXTICKS,
                        },
                        stacked: true,
                    }],
                yAxes: [{
                        stacked: true,
                    }],
            },
        };
        if (props.tooltipLabel) {
            opt.tooltips = {
                enabled: true,
                callbacks: {
                    label: function (item, data) {
                        var l = data.datasets[item.datasetIndex].label ? data.datasets[item.datasetIndex].label + ": " : "";
                        return !!props.tooltipPrefix
                            ? "" + l + props.tooltipLabel + data.datasets[item.datasetIndex].data[item.index]
                            : "" + l + data.datasets[item.datasetIndex].data[item.index] + props.tooltipLabel;
                    },
                },
            };
        }
        return opt;
    };
    var getPieOptions = function () {
        var opt = {
            cutoutPercentage: props.cutoutPercentage || 0,
            maintainAspectRatio: false,
            legend: {
                display: !!props.legend,
                position: props.legend,
                labels: {
                    usePointStyle: true,
                    pointStyle: 'circle',
                },
            },
        };
        if (props.piePercentage || props.tooltipLabel) {
            opt.tooltips = {
                enabled: true,
                callbacks: {
                    label: function (item, data) {
                        var value = data.datasets[0].data[item.index];
                        var percentage = "";
                        if (props.piePercentage) {
                            var total = data.datasets[0].data.reduce(function (acc, d) { return acc + d; }, 0);
                            percentage = " (" + (total ? Math.round(1000 * value / total) / 10 : 0) + "%)";
                        }
                        var l = data.labels[item.index] ? data.labels[item.index] + ": " : "";
                        return !!props.tooltipPrefix
                            ? "" + l + (props.tooltipLabel || "") + value + percentage
                            : "" + l + value + (props.tooltipLabel || "") + percentage;
                    },
                },
            };
        }
        return opt;
    };
    if (!react_chartjs_2) {
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(Grid_1.default, { item: true, xs: true, elevation: 0, component: Card_1.default },
                react_1.default.createElement(CardContent_1.default, { style: { padding: 24 } },
                    react_1.default.createElement(Grid_1.default, { container: true, direction: "column" },
                        react_1.default.createElement(Grid_1.default, { container: true, direction: "row", alignItems: "center", spacing: 1 },
                            react_1.default.createElement(Grid_1.default, { item: true, xs: 12 },
                                react_1.default.createElement(Typography_1.default, { variant: "body1", className: classes.title }, "ChartCard Error"))),
                        react_1.default.createElement(Divider_1.default, { variant: "fullWidth", className: classes.divider }),
                        react_1.default.createElement(Grid_1.default, { item: true, xs: 12 }, "Peer dependencies not installed"))))));
    }
    if (!props.type || (!props.dataSets && !props.pieDataSet)) {
        return null;
    }
    var currentData;
    var options;
    var noData;
    switch (props.type) {
        case "bar":
            currentData = formatBarData();
            options = getBarOptions();
            noData = !currentData.datasets.some(function (d) { var _a; return (_a = d.data) === null || _a === void 0 ? void 0 : _a.length; });
            break;
        case "line":
            currentData = formatLineData();
            options = getLineOptions();
            noData = !currentData.datasets.some(function (d) { var _a; return (_a = d.data) === null || _a === void 0 ? void 0 : _a.length; });
            break;
        case "pie":
            currentData = formatPieData();
            options = getPieOptions();
            noData = !currentData.datasets.some(function (d) { var _a; return ((_a = d.data) === null || _a === void 0 ? void 0 : _a.reduce(function (acc, p) { return acc + p; }, 0)) > 0; });
            break;
    }
    return (react_1.default.createElement(Grid_1.default, { item: true, xs: true, elevation: 0, component: Card_1.default, style: { height: "100%" } },
        react_1.default.createElement(CardContent_1.default, { style: { padding: 24 } },
            react_1.default.createElement(Grid_1.default, { container: true, direction: "column", spacing: 0 },
                react_1.default.createElement(Grid_1.default, { container: true, direction: "row", alignItems: "center", spacing: 1 },
                    !!props.chartSubtitle && (react_1.default.createElement(Grid_1.default, { item: true, xs: 12, style: { marginBottom: -8 } },
                        react_1.default.createElement(Typography_1.default, { variant: "body1", className: classes.title }, props.chartSubtitle))),
                    react_1.default.createElement(Grid_1.default, { item: true, xs: props.button ? 8 : 12, sm: props.button ? 9 : 12, style: { minHeight: 60, display: "flex", alignItems: "center" } },
                        react_1.default.createElement(Grid_1.default, { container: true, style: { display: "flex" } },
                            react_1.default.createElement(Grid_1.default, { item: true },
                                react_1.default.createElement(Typography_1.default, { variant: "h2", className: classes.subtitle }, props.chartTitle || ((_a = props.dataSets) === null || _a === void 0 ? void 0 : _a.label))),
                            !!props.chartInfo && (react_1.default.createElement(Grid_1.default, { item: true },
                                react_1.default.createElement("div", { className: "w100 h100 x6" },
                                    react_1.default.createElement(Tooltip_1.default, { title: utils_1.renderStringWithHTML(props.chartInfo) },
                                        react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_light_svg_icons_1.faCircleInfo, className: classes.icon }))))))),
                    !!props.button && react_1.default.createElement(Grid_1.default, { item: true, xs: 4, sm: 3 },
                        react_1.default.createElement(Grid_1.default, { container: true, justifyContent: "flex-end" },
                            react_1.default.createElement(Grid_1.default, { item: true }, props.button)))),
                react_1.default.createElement(Divider_1.default, { variant: "fullWidth", className: classes.divider }),
                react_1.default.createElement(Grid_1.default, { item: true, xs: 12 }, props.errorMessage ? react_1.default.createElement("div", { className: classes.noData }, props.errorMessage)
                    : (noData ? react_1.default.createElement("div", { className: classes.noData }, strings_1.default.chart.noData)
                        : (props.type === "bar"
                            ? react_1.default.createElement(react_chartjs_2.Bar, { type: "bar", data: currentData, options: options, height: 300 })
                            : (props.type === "line"
                                ? react_1.default.createElement(react_chartjs_2.Line, { type: "line", data: currentData, options: options, height: 300 })
                                : react_1.default.createElement(react_chartjs_2.Pie, { type: "doughnut", data: currentData, options: options, height: 300 })))))))));
};
exports.ChartCard = ChartCard;
